import { genLinkSeoVex } from './genLinkSeo';
import { slugify } from './stringConvert';

export const routeCompanyToCity = (endPoint: any, company: string, companyName: string) => (`
{
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement":
    [
       {
          "@type": "ListItem",
          "position": 1,
          "item":
          {
              "@id": "Goyolo.com",
              "name": "Goyolo.com"
          }
       },
      {
          "@type": "ListItem",
          "position": 2,
          "item":
          {
               "@id": "Goyolo.com/vn/ve-may-bay.vi",
               "name": "Vé máy bay giá rẻ"
          }
     },
    {
        "@type": "ListItem",
        "position": 3,
        "item":
        {
            "@id": "Goyolo.com/vn/ve-may-bay/di-${slugify(endPoint?.location)}.${endPoint?.id}.vi",
            "name": "Vé máy bay giá rẻ đi ${endPoint?.location}"
        }
    },
   {
        "@type": "ListItem",
        "position": 4,
        "item":
        {
             "@id": "Goyolo.com/vn/ve-may-bay/${slugify(company)}-di-${slugify(endPoint?.location)}.${endPoint?.id}.vi",
             "name": "Vé máy bay ${companyName} đi ${endPoint?.location}"
        }
     }
   ]
}`);

export const getRouteToCityMeta = (endPoint: any) => (`
{
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement":
    [
       {
          "@type": "ListItem",
          "position": 1,
          "item":
          {
              "@id": "Goyolo.com",
              "name": "Goyolo.com"
          }
       },
      {
          "@type": "ListItem",
          "position": 2,
          "item":
          {
               "@id": "Goyolo.com/vn/ve-may-bay.vi",
               "name": "Vé máy bay giá rẻ"
          }
     },
    {
        "@type": "ListItem",
        "position": 3,
        "item":
        {
            "@id": "Goyolo.com/vn/ve-may-bay/di-${slugify(endPoint?.location)}.${endPoint?.id}.vi",
            "name": "Vé máy bay giá rẻ đi ${endPoint?.location}"
        }
    }
   ]
}`);

export const getRouteCompanyCityToCityMeta = (endPoint: any, startPoint: any, company: string) => (`
{
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement":
    [
       {
          "@type": "ListItem",
          "position": 1,
          "item":
          {
              "@id": "Goyolo.com",
              "name": "Goyolo.com"
          }
       },
      {
          "@type": "ListItem",
          "position": 2,
          "item":
          {
               "@id": "Goyolo.com/vn/ve-may-bay.vi",
               "name": "Vé máy bay giá rẻ"
          }
     },
    {
        "@type": "ListItem",
        "position": 3,
        "item":
        {
            "@id": "Goyolo.com/vn/ve-may-bay/${company}.vi",
            "name": "Vé máy bay giá rẻ đi ${endPoint?.location}"
        }
    },
   {
        "@type": "ListItem",
        "position": 4,
        "item":
        {
             "@id": "Goyolo.com/vn/ve-may-bay/${company}-tu-${slugify(startPoint?.location)}-di-${slugify(endPoint?.location)}.${startPoint?.id}.${endPoint?.id}.vi",
             "name": "Vé máy bay giá rẻ từ ${startPoint?.location} đi ${endPoint?.location}"
        }
     }
   ]
}`);

export const getRoutePageMetaJson = (endPoint: any, startPoint: any, company?: string) => (`
{
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement":
    [
       {
          "@type": "ListItem",
          "position": 1,
          "item":
          {
              "@id": "Goyolo.com",
              "name": "Goyolo.com"
          }
       },
      {
          "@type": "ListItem",
          "position": 2,
          "item":
          {
               "@id": "Goyolo.com/vn/ve-may-bay.vi",
               "name": "Vé máy bay giá rẻ"
          }
     },
    {
        "@type": "ListItem",
        "position": 3,
        "item":
        {
            "@id": "Goyolo.com/vn/ve-may-bay/di-${slugify(endPoint?.location)}.${endPoint?.id}.vi",
            "name": "Vé máy bay giá rẻ đi ${endPoint?.location}"
        }
    },
   {
        "@type": "ListItem",
        "position": 4,
        "item":
        {
             "@id": "Goyolo.com/vn/ve-may-bay/${company || ''}-tu-${slugify(startPoint?.location)}-di-${slugify(endPoint?.location)}.${startPoint?.id}.${endPoint?.id}.vi",
             "name": "Vé máy bay giá rẻ từ ${startPoint?.location} đi ${endPoint?.location}"
        }
     }
   ]
}`);
export const getRoutePageMetaVexJson = (endPoint: any, startPoint: any, vexHostPath?: any) => (`
{
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement":
    [
       {
          "@type": "ListItem",
          "position": 1,
          "item":
          {
              "@id": "Vexere.com",
              "name": "Vexere.com"
          }
       },
    {
        "@type": "ListItem",
        "position": 2,
        "item":
        {
            "@id": "${vexHostPath}/${genLinkSeoVex({
    endName: endPoint?.location,
    endId: endPoint?.id,
    endStateName: endPoint?.stateName,
  })}",
            "name": "Vé máy bay đi ${endPoint?.location}"
        }
    },
   {
        "@type": "ListItem",
        "position": 3,
        "item":
        {
             "@id": "${vexHostPath}/${genLinkSeoVex({
    startName: startPoint.location,
    startId: startPoint.id,
    startStateName: startPoint?.stateName,
    endName: endPoint?.location,
    endId: endPoint?.id,
    endStateName: endPoint?.stateName,
  })}",
             "name": "Vé máy bay từ ${startPoint?.location} đi ${endPoint?.location}"
        }
     }
   ]
}`);

export const routeCompanyToCityVex = (endPoint: any, company: string, companyName: string, vexHostPath: string) => (`
{
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement":
    [
       {
          "@type": "ListItem",
          "position": 1,
          "item":
          {
              "@id": "Vexere.com",
              "name": "Vexere.com"
          }
       },
      {
          "@type": "ListItem",
          "position": 2,
          "item":
          {
               "@id": "${vexHostPath}.vi",
               "name": "Vé máy bay giá rẻ"
          }
     },
    {
        "@type": "ListItem",
        "position": 3,
        "item":
        {
            "@id": "${vexHostPath}/${genLinkSeoVex({
    endName: endPoint?.location,
    endId: endPoint?.id,
    endStateName: endPoint?.stateName,
  })}",
            "name": "Vé máy bay giá rẻ đi ${endPoint?.location}"
        }
    },
   {
        "@type": "ListItem",
        "position": 4,
        "item":
        {
             "@id": "${vexHostPath}/${genLinkSeoVex({
    company,
    endName: endPoint?.location,
    endId: endPoint?.id,
    endStateName: endPoint?.stateName,
  })}",
             "name": "Vé máy bay ${companyName} đi ${endPoint?.location}"
        }
     }
   ]
}`);

export const getRouteCompanyCityToCityMetaVex = (endPoint: any, startPoint: any, company: string, vexHostPath?: string) => (`
{
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement":
    [
       {
          "@type": "ListItem",
          "position": 1,
          "item":
          {
              "@id": "Vexere.com",
              "name": "Vexere.com"
          }
       },
      {
          "@type": "ListItem",
          "position": 2,
          "item":
          {
               "@id": "${vexHostPath}.vi",
               "name": "Vé máy bay giá rẻ"
          }
     },
    {
        "@type": "ListItem",
        "position": 3,
        "item":
        {
            "@id": "${vexHostPath}/${company}.vi",
            "name": "Vé máy bay giá rẻ đi ${endPoint?.location}"
        }
    },
   {
        "@type": "ListItem",
        "position": 4,
        "item":
        {
             "@id": "${vexHostPath}/${genLinkSeoVex({
    company,
    startName: startPoint.location,
    startId: startPoint.id,
    startStateName: startPoint?.stateName,
    endName: endPoint?.location,
    endId: endPoint?.id,
    endStateName: endPoint?.stateName,
  })}",
             "name": "Vé máy bay giá rẻ từ ${startPoint?.location} đi ${endPoint?.location}"
        }
     }
   ]
}`);

export const getRouteToCityMetaVex = (endPoint: any, path: string) => (`
{
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement":
    [
       {
          "@type": "ListItem",
          "position": 1,
          "item":
          {
              "@id": "Vexere.com",
              "name": "Vexere.com"
          }
       },
      {
          "@type": "ListItem",
          "position": 2,
          "item":
          {
               "@id": "${path}.vi",
               "name": "Vé máy bay giá rẻ"
          }
     },
    {
        "@type": "ListItem",
        "position": 3,
        "item":
        {
            "@id": "${path}/${genLinkSeoVex({
    endName: endPoint?.location,
    endId: endPoint?.id,
    endStateName: endPoint?.stateName,
  })}",
            "name": "Vé máy bay giá rẻ đi ${endPoint?.location}"
        }
    }
   ]
}`);
